export default "__VITE_ASSET__CIMGsVtZ__"